import MainComponent from "components/Main";
import { ReactComponent as CloseIcon } from 'icons/components/close.svg';
import './index.less';
import './themes/default.less';
export default class FilterItem extends MainComponent {

    onClose() {
        const { id, value, onClose } = this.props;

        if (onClose?.apply) {
            onClose({ id, value });
        }

    }

    render() {

        const { labelType, labelValue } = this.props;

        return (
            <div className="filterItem flex centerH">
                <div className="text textType">{labelType}</div>
                <div className="text textValue">{labelValue}</div>
                <div className="flex centerV hand" onClick={this.onClose.bind(this)} style={{ width: "15px" }}><CloseIcon className="closeIcon" /></div>
            </div>
        );
    }

}
